'use strict';

var util = require('_core_ext/util'),
    layout = require('_core_ext/layout'),
    JSCommonConstants = require('_core_ext/constants'),
    JSConstants = require('_core_ext/pages/search/constants');

var initialized = false,
    inactiveClass = 'inactive',
    hiddenClass = 'hidden',
    close = 'close',
    $cache = {},
    $brandsLink = $('.js-brands_item'),
    brandsContainer = '.js-brands_container';

function brandsAccordion() {
    $brandsLink.on('click', function() {
        if (!layout.isDesktop()) {
            $(this).toggleClass(close);
            $(this).next(brandsContainer).toggle();
        }
    });
}

function showBrands() {
    $brandsLink.removeClass(close);
    $brandsLink.next('.js-brands_container').show();
}

function scrollToBrandsGroup() {
    var $this = $(this);
    if (!$this.hasClass(inactiveClass)) {
        var $brandsGroup = $cache.document.find('.js-brands_group[data-brandletter=' + $this.data('brandletter') + ']');
        if ($brandsGroup.length) {
            util.scrollBrowser($brandsGroup.offset().top, 500, layout.isMobile());
        }
    }

    showBrands();
}

function initScrollToBrandGroups() {
    var anchor = util.getParameterValueFromUrl('anchor', location.href);
    if (anchor) {
        scrollToAnchor(anchor);
        let imgs = Array.from(document.querySelectorAll("img"));
        let loudImg = imgs.map(function (img) {
            return new Promise(function(res) {
                img.addEventListener('load', () => {
                    res();
                });
            });
        });

        Promise.all(loudImg)
            .then(scrollToAnchor(anchor));
    }
}

function scrollToAnchor (anchor) {
    var $brandsGroup = $cache.document.find('.js-brands_group[data-brandletter=' + anchor + ']').find('.js-brands_item');
    if (!layout.isMobile()) {
        $brandsGroup[0].scrollIntoView({behavior: "smooth"});
    } else {
        util.scrollBrowser($brandsGroup.offset().top, 800, true);
    }
}

function updateBrands() {
    $.each($('.js-brand_letter'), function() {
        var $this = $(this),
            $brandsGroup = $cache.document.find('.js-brands_group[data-brandletter=' + $this.data('brandletter') + ']'),
            $brandContent = $brandsGroup.find('.js-brand_content');
            $brandsGroup.removeClass(hiddenClass);
        if ($brandsGroup.find('.js-brand_link:visible').length) {
            $this.removeClass(inactiveClass);
            $brandContent.removeClass(hiddenClass);
        } else {
            $this.addClass(inactiveClass);
            $brandContent.addClass(hiddenClass);
            $brandsGroup.addClass(hiddenClass);
        }
    });
}

function searchBrands() {
    var $this = $(this),
        regEx = new RegExp('(?:^|\\s)' + $this.val(), 'i');

    $.each($('.js-brand_link'), function() {
        var $this = $(this);
        if ($this.data('brandname')) {
            var selection = $this.data('brandname').match(regEx);
            if (selection) {
                $this.closest('.js-brand_link_wrapper').removeClass(hiddenClass);
                $this.html($this.text().replace(selection[0], '<b>' + selection[0] + '</b>'));
            } else {
                $this.parent('.js-brand_link_wrapper').addClass(hiddenClass);
            }
        }
    });

    updateBrands();
    showBrands();
}

function initializeCache() {
    $cache.document = $(initScrollToBrandGroups);
    $cache.stickyheader = layout.isMobile() ? $cache.document.find(JSCommonConstants.CLASS_STICKY_HEADER_MOBILE) : $cache.document.find(JSConstants.CLASS_HEADER_MIDDLE);
}

function initializeEvents() {
    $cache.document
        .on('click', '.js-brand_letter', scrollToBrandsGroup)
        .on('input', '.js-brands_search', searchBrands)
        .on('submit', '.js-brands_form', function(e) {
            e.preventDefault();
        });

    brandsAccordion();
}

module.exports = {
    init: function() {
        if (initialized) {
            return;
        }
        initializeCache();
        initializeEvents();
        initialized = true;
    }
};
